/**
 * Help menu item definition
 */
export interface HelpMenuItem {
	href: string;
	title: string;
	description: string;
	disabled?: boolean;
}

/**
 * Help menu items for navigation
 */
export const HELP_MENU_ITEMS: HelpMenuItem[] = [
	{
		href: "/pricing",
		title: "Pricing",
		description: "View our pricing plans",
	},
	{
		href: "/developers",
		title: "Developers",
		description: "Coming soon",
		disabled: true,
	},
	// {
	// 	href: "/docs",
	// 	title: "Documentation",
	// 	description: "Learn how to create and manage AI teammates",
	// },
];

/**
 * Featured "Getting Started" section content
 */
export const GETTING_STARTED_CONTENT = {
	title: "Delegate your work",
	description: "With company knowledge to take actions in your apps",
};
